<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6">
      <div class="card shadow-sm border-0 rounded-4">
        <div class="card-body p-4 p-md-5 text-center">

          <div *ngIf="state === 'loading'" class="mb-4">
            <div class="spinner-border" role="status"></div>
          </div>

          <div *ngIf="state === 'success'" class="mb-4">
            <div class="display-5">✅</div>
          </div>

          <div *ngIf="state === 'pending'" class="mb-4">
            <div class="display-5">⏳</div>
          </div>

          <div *ngIf="state === 'failed'" class="mb-4">
            <div class="display-5">❌</div>
          </div>

          <h3 class="fw-bold mb-2">{{ title }}</h3>
          <p class="text-muted mb-4">{{ message }}</p>

          <div *ngIf="result" class="card border-0 bg-light rounded-4 text-start mb-4">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Reference</span>
                <span class="fw-semibold">{{ result.externalReference }}</span>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Amount</span>
                <span class="fw-semibold">{{ result.amount | smartAmount }} {{ result.currencyCode }}</span>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Status</span>
                <span class="fw-semibold text-capitalize">{{ result.status }}</span>
              </div>

              <div class="d-flex justify-content-between" *ngIf="result.gatewayName">
                <span class="text-muted">Gateway</span>
                <span class="fw-semibold">{{ result.gatewayName }}</span>
              </div>
            </div>
          </div>

          <div class="d-flex gap-2 justify-content-center flex-wrap">
            <button class="btn btn-primary" type="button" (click)="goToConfirmation()" *ngIf="result">
              Continue
            </button>

            <button class="btn btn-outline-secondary" type="button" (click)="goHome()">
              Back Home
            </button>

            <button
              *ngIf="state !== 'success'"
              class="btn btn-outline-dark"
              type="button"
              (click)="retryVerification()">
              Retry Verification
            </button>
          </div>

          <div class="small text-muted mt-3" *ngIf="state === 'success'">
            Redirecting to confirmation page...
          </div>

        </div>
      </div>
    </div>
  </div>
</div>